export const LOCAL = 'local';
export const DEV = 'dev';
export const UAT = 'uat';
export const PRO = 'pro';
